import fetch from 'isomorphic-fetch';


export const API_URL = process.env.REACT_APP_EVENT_API_URL || 'https://prod-api.vmnk.in/event-service';
// export const API_URL = 'http://localhost:8003';


export default function eventCallApi(endpoint, method = 'get', body,noApi=false, loginapi=false) {
  let token;
  if(loginapi){
  token = typeof window === 'undefined' ? '' : window.localStorage.getItem('token');
  } else {
  token = typeof window === 'undefined' ? '' : window.localStorage.getItem('idToken');
  }
  let headers = {};
  headers['content-type'] = 'application/json';
  if (token && token !== '') {
    headers.Authorization = `Bearer ${token}`;
  }
  const FINAL_URL = `${API_URL}/${noApi===false?'api/':''}${endpoint}`
  return fetch(FINAL_URL, {
    headers: headers,
    method,
    body: JSON.stringify(body),
    referrer: '',
    referrerPolicy: 'origin-when-cross-origin'
  }).then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
    })
    .then(
      response => response,
      error => error
    );
}

